import React from 'react';
import { CellTemplateProps, ColumnProps } from 'fulogics-ui-web';
import GridColumnInspectorHelper from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/GridColumnInspectorHelper';
import ValidationInfo, {
    ValidationInfoData,
    ValidationInfoDataKeys,
    ValidationInfoDisplayOptions,
} from './ValidationInfo';

const ValidationInfoColumnTemplate = (props: CellTemplateProps) => (
    <GridColumnInspectorHelper cellProps={props}>
        {(inspectorId, disableInspectorForm) => (
            <ValidationInfo
                disableInspectorForm={disableInspectorForm}
                inspectorId={inspectorId}
                data={props.data}
                defaultProps={ValidationInfoColumnTemplateDefaultProps}
            />
        )}
    </GridColumnInspectorHelper>
);

export const ValidationInfoColumnTemplateDefaultProps = {} as ValidationInfoDisplayOptions;

export const ValidationInfoColumnTemplatePredProps = (current: ColumnProps): ColumnProps => {
    return {
        ...current,
    };
};

export type ValidationInfoColumnTemplateData = ValidationInfoData & {};

export const ValidationInfoColumnTemplateDataKeys = [...ValidationInfoDataKeys];

export default ValidationInfoColumnTemplate;
